import React from 'react';
import {Link} from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';

const Footer = () => {
    return (
        <>
            <footer>
                <div className="footer max-w-full mx-auto px-4 sm:px-6 bg-gray-100 border-t border-b py-30">

                    {/* Top area: Blocks */}
                    <div className="grid sm:grid-cols-12 gap-5 py-8 md:py-12 border-t border-gray-200 lg:ml-11">

                    {/* 1st block */}
                    <div className="col-span-12 lg:col-span-3">
                        <div className="box-border border-b-4 border-blue-900 p-8 bg-gray-200 text-gray-600 rounded-lg xl:w-80 mx-auto">
                            <div className="flex flex-col items-center">
                                <h3 className="font-bold text-4xl mb-2 text-blue-900">NexAI</h3>
                                <div className="w-12 h-1 bg-blue-900 mb-4"></div>
                                <div className='text-md space-y-3'>
                                    <div className="flex items-center space-x-2">
                                        <svg className="w-5 h-5 text-blue-900" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"/>
                                        </svg>
                                        <span className="font-semibold">NexAI Solution</span>
                                    </div>
                                    <div className="flex items-center space-x-2">
                                        <svg className="w-5 h-5 text-blue-900" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"/>
                                        </svg>
                                        <HashLink to="/contact#contact" className="hover:text-blue-900 transition duration-300">
                                            Contact Us
                                        </HashLink>
                                    </div>
                                    <div className="text-center mt-4">
                                        <p className="font-medium">Your Trusted Partner in</p>
                                        <p className="font-semibold text-blue-900">AI & Software Development</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* 2nd block */}
                    <div className="col-span-6 md:col-span-6 lg:col-span-3 ml-7 mx-auto">
                        <h6 className="text-[#013289] text-xl font-bold mb-4">LINKS</h6>
                        <ul className="text-md">
                            <li className="mb-2">
                                <HashLink to="/#about" className="text-[#013289] hover:text-gray-900 hover:tracking-wider transition duration-250 ease-in-out">
                                    About
                                </HashLink>
                            </li>
                            <li className="mb-2">
                                <HashLink to="/#services" className="text-[#013289] hover:text-gray-900 hover:tracking-wider transition duration-250 ease-in-out">
                                    Services
                                </HashLink>
                            </li>
                            <li className="mb-2">
                                <HashLink to="/contact#contact" className="text-[#013289] hover:text-gray-900 hover:tracking-wider transition duration-250 ease-in-out">
                                    Contact Us
                                </HashLink>
                            </li>
                            <li className="mb-2">
                                <HashLink to="/get-demo#demo" className="text-[#013289] hover:text-gray-900 hover:tracking-wider transition duration-250 ease-in-out">
                                    Demo our services
                                </HashLink>
                            </li>
                        </ul>
                    </div>

                    {/* 3rd block */}
                    <div className="col-span-6 md:col-span-6 lg:col-span-3 mx-auto">
                        <h6 className="text-[#013289] text-xl font-bold mb-4">OUR SERVICES</h6>
                        <ul className="text-md">
                            <li className="mb-2">
                                <Link to="/ai-solutions" className="text-[#013289] hover:text-gray-900 hover:tracking-wider transition duration-250 ease-in-out">AI Solutions</Link>
                            </li>
                            <li className="mb-2">
                                <Link to="/software-development" className="text-[#013289] hover:text-gray-900 hover:tracking-wider transition duration-250 ease-in-out">Software Development</Link>
                            </li>
                            <li className="mb-2">
                                <Link to="/cloud-devops" className="text-[#013289] hover:text-gray-900 hover:tracking-wider transition duration-250 ease-in-out">Cloud & DevOps</Link>
                            </li>
                            <li className="mb-2">
                                <Link to="/it-consulting" className="text-[#013289] hover:text-gray-900 hover:tracking-wider transition duration-250 ease-in-out">IT Consulting</Link>
                            </li>
                        </ul>
                    </div>

                    {/* 4th block */}
                    <div className="col-span-12 lg:col-span-3 text-center mx-auto">
                        <h6 className="text-[#013289] text-xl font-bold mb-4">SOCIAL MEDIA</h6>
                        <div className="text-md font-medium mb-6 text-gray-600">
                            Follow us on social media
                        </div>
                        <div className="mx-auto text-center mt-2">
                            <ul className="flex justify-center space-x-4">
                                <li>
                                    <a 
                                        href="https://www.facebook.com/profile.php?id=61571704648368" 
                                        target="_blank" 
                                        rel="noreferrer" 
                                        className="flex justify-center items-center text-blue-900 hover:text-gray-500 bg-white hover:bg-white-100 rounded-full shadow transition duration-150 ease-in-out p-2"
                                        aria-label="Facebook"
                                    >
                                        <svg className="w-8 h-8 fill-current" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M14.023 24L14 17h-3v-3h3v-2c0-2.7 1.672-4 4.08-4 1.153 0 2.144.086 2.433.124v2.821h-1.67c-1.31 0-1.563.623-1.563 1.536V14H21l-1 3h-2.72v7h-3.257z" />
                                        </svg>
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>

                    </div>

                </div>

                {/* Bottom area */}
                <div className="flex justify-center py-4 bg-gray-200">
                    <div className="text-sm text-gray-600">
                        <span>&copy; {new Date().getFullYear()} NexAI Solution. All rights reserved.</span>
                    </div>
                </div>

            </footer>
        </>
    )
}

export default Footer;
